import images from '../../generated/images.json';

// Uploaded/remote images pass through unchanged. Local illustrations and logos
// select a size suited to the display while keeping intrinsic dimensions.
export default function OptimizedImage({ src, alt, sizes, width, height, fetchPriority, loading, decoding = 'async', ...props }) {
  const asset = images[src];
  const isNewsImage = /^https:\/\/(?:webapi|appapi)\.todago\.site\/api\/news\/[a-f0-9]{24}\/image(?:\?|$)/i.test(src || '');
  const isLogo = /(?:web_todago_logo|App_Logo_Tricycle)/.test(src || '');
  const displaySize = sizes || (isLogo ? (/App_Logo/.test(src) ? '44px' : '164px') : '(max-width: 720px) 90vw, 500px');
  // Keep the existing eager default for navigation logos, but honor an
  // explicit `loading="lazy"` for footer and below-the-fold images. This
  // avoids downloading hidden/secondary logos during the initial render.
  const imageLoading = loading || (isLogo ? 'eager' : 'lazy');
  return <img
    {...props}
    alt={alt}
    fetchpriority={fetchPriority}
    src={asset ? asset.variants[asset.variants.length - 1].src : isNewsImage ? `${src.split('?')[0]}?w=960` : src}
    srcSet={asset ? asset.variants.map(variant => `${variant.src} ${variant.width}w`).join(', ') : isNewsImage ? [320, 640, 960, 1280].map(size => `${src.split('?')[0]}?w=${size} ${size}w`).join(', ') : undefined}
    sizes={asset || isNewsImage ? displaySize : sizes}
    width={width || asset?.width}
    height={height || asset?.height}
    loading={imageLoading}
    decoding={decoding}
  />;
}
